import {
  switchMap,
  catchError,
  mergeMap,
} from 'rxjs/operators';
import {
  Observable,
  of,
  from,
} from 'rxjs';
import { ofType } from 'redux-observable';
import {
  InsightsActions,
  InsightsAction,
  LoadInsightsSuccess,
  LoadInsights,
  LoadInsightsError
} from '../actions/insights.action';
import { InsightsData } from '../../shared/models/insights';
import InsightsService from '../services/insights.service';

export const loadInsights = ($action: Observable<InsightsAction>) => $action.pipe(
  ofType<LoadInsights>(InsightsActions.LoadInsights),
  switchMap((action) => from(InsightsService.getTasksDetails(action.params)).pipe(
    mergeMap((data: InsightsData) => of(
      new LoadInsightsSuccess(data),
    )),
    catchError((error: Error) => of(new LoadInsightsError(error.message || 'Unknown insights loading error!'))),
  )),
);

const InsightsEpics = [
  loadInsights,
];

export default InsightsEpics;
